import { render, staticRenderFns } from "./layout-public.vue?vue&type=template&id=97fe973a"
import script from "./layout-public.vue?vue&type=script&lang=js"
export * from "./layout-public.vue?vue&type=script&lang=js"
import style0 from "./layout-public.vue?vue&type=style&index=0&id=97fe973a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports